module.exports = __webpack_public_path__ + "img/screen_print.efe9c5d2.jpg";